import type { ReactNode } from "react";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";

interface OfferDetailsProps {
  data: any;
}

interface Detail {
  label: string
  value: ReactNode
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1
  let secondLastValidRow = -1
  let validCount = 0

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow
      lastValidRow = i
      validCount++
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow]
}

export const ExistingLoanDetailsRow = ({ data }: OfferDetailsProps) => {
  const { ownExperience } = data?.integrations?.leabank ?? {}
  const ownExperienceData = ownExperience?.data

  const formatDays = (days?: number) => {
    if (days === null || days === undefined) {
      return null
    }

    return `${days} ${days === 1 ? "day" : "days"}`
  }

  const existingLoanDetails: Detail[] = [
    {
      label: "Top Up",
      value: "Yes",
    },
    {
      label: "Current loan amount",
      value: ownExperienceData?.openInvoices !== null && ownExperienceData?.openInvoices !== undefined
        ? `${new Intl.NumberFormat('es-ES').format(ownExperienceData.openInvoices)} €`
        : null,
    },
    {
      label: "Current nominal interest rate",
      value: ownExperienceData?.currentInt !== null && ownExperienceData?.currentInt !== undefined
        ? `${ownExperienceData.currentInt} %`
        : null,
    },
    {
      label: "Amount overdue",
      value: ownExperienceData?.amtOverDue !== null && ownExperienceData?.amtOverDue !== undefined
        ? `${new Intl.NumberFormat('es-ES').format(ownExperienceData.amtOverDue)} €`
        : null,
    },
    {
      label: "Days past due (DPD) as of today",
      value: formatDays(ownExperienceData?.dpd),
    },
    {
      label: "max DPD last 12 months",
      value: formatDays(ownExperienceData?.maxDPD12M),
    },
    {
      label: "Number of active accounts",
      value: ownExperienceData?.activeAccounts,
    },
    ...(ownExperienceData?.activeAccountNOs || []).map((account: string) => ({
      label: "Core Account number",
      value: account,
    })),
  ]

  const lastIndexes = getIndexOfLastRow(existingLoanDetails)
  const isEmpty = existingLoanDetails.every(
    (detail) => detail.value === null || detail.value === undefined,
  )

  if (isEmpty) return null

  return (
    <RowsWrapper className="Existing loan information">
      <NormalInfoWrapper $header>Existing Loan Details</NormalInfoWrapper>
      {existingLoanDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return
        return (
          <NormalInfoWrapper key={`existing-loan-${index}-${detail.label}`} $isLast={lastIndexes.includes(index)}>
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        )
      })}

    </RowsWrapper>
  )
}